export default "__VITE_ASSET__B$33bNv3__"